<template>
  <v-dialog v-model="dialog" max-width="900">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Add Closeouts</v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col sm="6">
            <v-text-field
              v-model="description"
              label="Name/Description (max 100 chars)"
              :maxlength="100"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <date-range-picker
              :gt-date-from-string="validFrom"
              :gt-date-to-string="validTo"
              @onRangeSelected="onDateRangeSelected"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6">
            <agent-group-select
              v-model="agentGroup"
              :outlined="outlinedInputs"
            ></agent-group-select>
          </v-col>
          <v-col>
            <gt-multi-select
              :items="inUseServices"
              label="Services"
              item-text="node.name"
              item-value="node.id"
              v-model="selectedServices"
              :outlined="outlinedInputs"
            ></gt-multi-select>
          </v-col>
          <v-col sm="1" v-if="false">
            <v-text-field
              type="number"
              v-model="max"
              label="Max"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="false">
            <v-select
              label="Type"
              v-model="type"
              :items="['pax', 'qty']"
              :outlined="outlinedInputs"
            ></v-select>
          </v-col>
          <v-col v-if="false">
            <v-text-field
              type="number"
              v-model="release"
              label="Release"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max1')($event)"
              v-model="max1"
              label="Mon"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max2')($event)"
              v-model="max2"
              label="Tue"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max3')($event)"
              label="Wed"
              v-model="max3"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max4')($event)"
              label="Thur"
              v-model="max4"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max5')($event)"
              label="Fri"
              v-model="max5"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max6')($event)"
              label="Sat"
              v-model="max6"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              @change="onDayChange('max7')($event)"
              label="Sun"
              v-model="max7"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col>[{{ selectedServices }}]</v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from "../../shared/DatesRangePicker";
import AgentGroupSelect from "../../shared/AgentGroupSelect";
import GtMultiSelect from "../../shared/GtMultiSelect";
import moment from "moment";
export default {
  name: "add-closeouts-dialog",
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DateRangePicker,
    AgentGroupSelect,
    GtMultiSelect,
  },
  data() {
    return {
      debug: false,
      description: "",
      dialog: false,
      validFrom: "",
      validTo: "",
      agentGroup: "",
      selectedServices:
        this.services.length > 0
          ? this.services.filter((s) => !s.node.notInUse).map((s) => s.node.id)
          : [],
      type: "pax",
      release: 0,
      max1: 0,
      max2: 0,
      max3: 0,
      max4: 0,
      max5: 0,
      max6: 0,
      max7: 0,
      max: 1,
    };
  },

  computed: {
    inUseServices() {
      return this.services.filter((s) => !s.node.notInUse);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.validFrom != "" &&
        this.validTo != "" &&
        this.name != "" &&
        this.selectedServices.length > 0
      );
    },
  },
  methods: {
    onDayChange(f) {
      return (event) => {
        this[f] = event ? 1 : 0;
      };
    },
    onDateRangeSelected(range) {
      this.validFrom = range.dateFrom;
      this.validTo = range.dateTo;
      this.setDaysOfWeek();
    },
    setAllDaysOfWeek(val) {
      for (let i = 1; i <= 7; i++) {
        this[`max${i}`] = val;
      }
    },
    setDaysOfWeek() {
      this.setAllDaysOfWeek(0);
      const daysDiff = moment(this.validTo).diff(
        moment(this.validFrom),
        "days"
      );
      const start = moment(this.validFrom).day();
      let end = moment(this.validTo).day();
      if (end == 0) {
        end = 7;
      }
      if (daysDiff >= 7) {
        //select all days
        this.setAllDaysOfWeek(1);
      } else {
        //just days of week on selected date range
        for (let j = start; j <= end; j++) {
          this[`max${j}`] = 1;
        }
      }
    },
    onBookBeforeSelected(date) {
      this.bookBeforeDate = date;
    },
    onSave() {
      this.dialog = false;
      this.$emit("create", {
        validFrom: this.validFrom,
        validTo: this.validTo,
        groupId: this.agentGroup,
        description: this.description,
        type: this.type,
        services: this.selectedServices,
        release: Number(this.release),
        max1: Number(this.max1),
        max2: Number(this.max2),
        max3: Number(this.max3),
        max4: Number(this.max4),
        max5: Number(this.max5),
        max6: Number(this.max6),
        max7: Number(this.max7),
        max: Number(this.max),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/closeouts/AddCloseoutsDialog.vue